import React from "react";
function ProcessFlowIntegrationMethods() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_layout">
              <h1>Process Flow & Integration Methods</h1>
              <hr />
              <p class="mt-30">
                <b>Safexpay</b> supports collecting payment information using the following 4 methods majorly. 
              </p>

              <ul>
                <li>
                  <b>Aggregator Hosted (Non-Seamless)</b>
                </li>
                <li>
                  <b>Merchant Hosted (Seamless)</b>
                </li>
                {/* <li>
                  <b>Aggregator with Paymode Hosted</b>
                </li> */}
                <li>
                  <b>JS Checkout</b>
                </li>
                <li>
                  <b>API Integration</b>
                </li>
              </ul>

           

              {/* <section id="idocs_content" class="mt-20 mb-20">
                <h2>1. Aggregator Hosted (Non-Seamless):</h2>
                <hr />
              </section> */}

              {/* <p>
                Avoid struggling to develop and manage your own checkout
                page.Use the customized payment page provided by <b>Safexpay</b>{" "}
                which enables you to collect payment from thecustomer.
              </p>

              <p>
                <b>Safexpay</b> payment page is fully customize enabling you to
                match the look and feel of your website with respect to Font and
                Colors.
              </p>

              <p>
                Processing orders using <b>Safexpay</b> payment page.
              </p> */}
            </section>

           
            {/* <u>
              <h4>Process flow</h4>
            </u>

            <ol>
              <li>
                <p>
                  Customer selects product/service on your website and proceedsto
                  make payment.
                </p>
              </li>
              <li>
                <p>
                  Customer is redirected to the <b>Safexpay</b> payment page
                  where payment information is entered by the customer.
                </p>
              </li>
              <li>
                <p>
                  On submission of the transaction information, <b>Safexpay</b>{" "}
                  initiates the authorization process by connecting to the
                  relevant bank / processing organization.
                </p>
              </li>
              <li>
                <p>
                  .On receiving the authorization status from the bank,{" "}
                  <b>Safexpay</b> sends the response back to your website with
                  the transaction status.
                </p>
              </li>
            </ol> */}


            {/* <section id="idocs_content" class="mt-20 mb-20">
                <h2>Safexpay Test Environments for Aggregator Hosted (Non-Seamless)</h2>
                <hr />
              </section> */}

            {/* <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Post URL</td>
                  <td>
                 
                    <a href="#">
                    https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage                    </a>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Merchant ID</td>
                  <td>202308230001</td>
                </tr>
                <tr>
                  <td className="table-color">Encryption Key</td>
                  <td>fjlYSgpw0TfzvZmZ5xvtHRpwFgCejkM33x4jsRrCISo</td>
                </tr>
                <tr>
                  <td className="table-color">AggregatorID</td>
                  <td> Paygate</td>
                </tr>
              </tbody>
            </table> */}


            {/* <u>
              <h4>Request Parameters</h4>
            </u> */}

            {/* <p>Merchant must send the following parameters to Safexpay PG for processing an order.</p> */}

            {/* <section id="idocs_content" class="mt-20 mb-20">
              <h2>Safexpay Production Environments</h2>
              <hr />
            </section>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Post URL</td>
                  <td>
                    {" "}
                    <a href="#">
                      https://pg.safexpay.ae/agcore/paymentProcessing
                    </a>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Merchant ID</td>
                  <td>Shared by us</td>
                </tr>
                <tr>
                  <td className="table-color">Encryption Key</td>
                  <td>Shared by us</td>
                </tr>
                <tr>
                  <td className="table-color">AggregatorID</td>
                  <td> Paygate</td>
                </tr>
              </tbody>
            </table> */}
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default ProcessFlowIntegrationMethods;
